"use client";
import * as t from "react";
const n = /* @__PURE__ */ t.createContext(void 0);
process.env.NODE_ENV !== "production" && (n.displayName = "DirectionContext");
function o(i = !0) {
  const e = t.useContext(n);
  if (e === void 0 && !i)
    throw new Error("Base UI: DirectionContext is missing.");
  return (e == null ? void 0 : e.direction) ?? "ltr";
}
export {
  o as u
};
